/**
 * BrandMark — the YourCal mark.
 *
 * Taken from the identity system in the landing repository
 * (`design/logo`, concept A, "Signal"): the calendar frame with its binding
 * posts, the eleven-dot grid, and the three waves that say the calendar is
 * broadcasting a change.
 *
 * It is wider than it is tall, so size it by height and let the width follow
 * from the viewBox. It draws in `currentColor`, which means the caller picks
 * the colour: the shell hands it `var(--text-accent)` and it follows the theme
 * without knowing which one is active.
 *
 * The path data is the same as `svg/concept-a-signal-mark-currentColor.svg` in
 * the identity system and `src/components/brand.tsx` on the landing page. It is
 * repeated rather than shared because the two apps are separate builds.
 */
export default function BrandMark({ style, ...rest }) {
  return (
    <svg
      viewBox="2.73 0.05 54.5 39.95"
      role="img"
      aria-label="YourCal"
      style={style}
      {...rest}
    >
      {/* Calendar frame and binding posts. */}
      <rect
        x="6.63"
        y="8.3"
        width="29.4"
        height="27.8"
        rx="3.9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
      />
      <path
        d="M14.66 3.95V11.5M28 3.95V11.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />

      {/*
        The dot grid: four columns by three rows with the bottom-right cell left
        empty, exactly as the supplied reference had it. Held as data so that
        missing cell stays visible in the code instead of hiding in a wall of
        <rect> elements.
      */}
      {[11.23, 16.83, 22.43, 28.03].flatMap((x) =>
        [18, 23.6, 29.2]
          .filter((y) => !(x === 28.03 && y === 29.2))
          .map((y) => (
            <rect
              key={`${x}-${y}`}
              x={x}
              y={y}
              width="3.4"
              height="2.6"
              rx="1.3"
              fill="currentColor"
            />
          )),
      )}

      {/* The broadcast: three waves leaving the frame's right edge. */}
      <path
        d="M43.565 18.6A7.2 7.2 0 0 1 43.565 25.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M47.376 16.4A11.6 11.6 0 0 1 47.376 28"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M51.186 14.2A16 16 0 0 1 51.186 30.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
